import { useEffect } from "react";
import Table from "react-bootstrap/Table";

import classes from "./CodesMovements.module.scss";

import { formatMilesDecimalNew } from "@/services/Utils";
import CustomBadge from "@/components/desktop/badge/CustomBadge";

const Applications = ({ data, applyFilterCode, applyFilterType, result, setResult }) => {
	useEffect(() => {
		let newData = data ? [...data.applications] : [];
		if (applyFilterCode !== "") {
			newData = newData.filter((item) => item.IDENTIFICADOR === applyFilterCode);
		}

		if (newData.length > 0 && applyFilterType === "general") {
			const groupAndSum = (data) => {
				const result = data.reduce((item, current) => {
					const key = `${current.NOMBRE_COMERCIAL}-${current.UNIDAD_DE_MEDIDA}-${current.TIPO_DE_MOVIMIENTO}-${current.FECHA}`;
					if (!item[key]) {
						item[key] = {
							NOMBRE_COMERCIAL: current.NOMBRE_COMERCIAL,
							UNIDAD_DE_MEDIDA: current.UNIDAD_DE_MEDIDA,
							TIPO_DE_MOVIMIENTO: current.TIPO_DE_MOVIMIENTO,
							FECHA: current.FECHA,
							TOTAL: 0,
							PRESENTACION_ENVASE: 0,
							CANTIDAD_PRODUCTO: 0,
							ENTRY: 0,
							IS_TRANSFER: current.IS_TRANSFER,
						};
					}
					if (["INVENTARIO", "COMPRA", "RECEPCIÓN"].includes(current.TIPO_DE_MOVIMIENTO)) {
						item[key].TOTAL += Number(String(current.PRESENTACION_ENVASE).replace(/,/g, "."));
						item[key].PRESENTACION_ENVASE += Number(String(current.PRESENTACION_ENVASE).replace(/,/g, "."));
						item[key].CANTIDAD_PRODUCTO += 0;
						item[key].ENTRY = 1;
					} else if (["SALIDA DE BODEGA", "APLICACIÓN", "TRASPASO", "NOTA DE CRÉDITO", "ROBO"].includes(current.TIPO_DE_MOVIMIENTO)) {
						item[key].TOTAL += Number(String(current.CANTIDAD_PRODUCTO).replace(/,/g, "."));
						item[key].PRESENTACION_ENVASE += 0;
						item[key].CANTIDAD_PRODUCTO += Number(String(current.CANTIDAD_PRODUCTO).replace(/,/g, "."));

						if (["SALIDA DE BODEGA"].includes(current.TIPO_DE_MOVIMIENTO)) {
							item[key].ENTRY = 0;
						}
						if (["APLICACIÓN", "TRASPASO", "NOTA DE CRÉDITO", "ROBO"].includes(current.TIPO_DE_MOVIMIENTO)) {
							item[key].ENTRY = 1;
						}
					}
					return item;
				}, {});

				return Object.values(result);
			};

			newData = groupAndSum(newData);
		}
		if (applyFilterType === "detail") {
			newData = newData.map((item) => {
				item.PRESENTACION_ENVASE = Number(String(item.PRESENTACION_ENVASE).replace(/,/g, "."));
				item.CANTIDAD_PRODUCTO = Number(String(item.CANTIDAD_PRODUCTO).replace(/,/g, "."));

				return item;
			});
		}

		setResult(newData);

		// eslint-disable-next-line
	}, [applyFilterType, applyFilterCode]);

	let accumulatedBalance = 0;

	return (
		<Table striped hover size="sm">
			<thead>
				<tr>
					<th className={classes.tableTh} style={{ width: "35%" }}>
						Producto
					</th>
					<th className={classes.tableTh} style={{ width: "15%" }}>
						Tipo de Movimiento
					</th>
					<th className={classes.tableTh} style={{ width: "15%" }}>
						Fecha
					</th>
					{applyFilterType === "detail" && <th className={classes.tableTh}>Código</th>}
					<th className={classes.tableTh} style={{ textAlign: "right" }}>
						Cant. Ingreso
					</th>
					<th className={classes.tableTh} style={{ textAlign: "right" }}>
						Cant. Uso
					</th>
					<th className={classes.tableTh} style={{ textAlign: "right" }}>
						Saldo
					</th>
				</tr>
			</thead>
			<tbody>
				{result.map((application, index) => {
					if (application.ENTRY) {
						accumulatedBalance += application.PRESENTACION_ENVASE ? application.PRESENTACION_ENVASE : 0;
					}
					if (application.ENTRY && ["APLICACIÓN", "TRASPASO", "NOTA DE CRÉDITO", "ROBO"].includes(application.TIPO_DE_MOVIMIENTO)) {
						accumulatedBalance -= application.CANTIDAD_PRODUCTO ? application.CANTIDAD_PRODUCTO : 0;
					}

					const PRESENTACION_ENVASE_DISPLAY = application.PRESENTACION_ENVASE ? String(application.PRESENTACION_ENVASE).replace(/\./g, ",") : 0;
					const CANTIDAD_PRODUCTO_DISPLAY = application.CANTIDAD_PRODUCTO ? String(application.CANTIDAD_PRODUCTO).replace(/\./g, ",") : 0;
					const BALANCE_DISPLAY = accumulatedBalance <= 0 ? 0 : String(accumulatedBalance).replace(/\./g, ",");

					if (!application.UNIDAD_DE_MEDIDA) {
						application.UNIDAD_DE_MEDIDA = "Kg";
					}

					if (application.TIPO_DE_MOVIMIENTO === "COMPRA" && application.IS_TRANSFER) {
						application.TIPO_DE_MOVIMIENTO = "TRASPASO COMPRA";
					}
					if (application.TIPO_DE_MOVIMIENTO === "TRASPASO") {
						application.TIPO_DE_MOVIMIENTO = "TRASPASO USO DE PRODUCTO";
					}

					let variantBadge = "success";
					if (["INVENTARIO", "COMPRA", "RECEPCIÓN", "TRASPASO", "TRASPASO COMPRA"].includes(application.TIPO_DE_MOVIMIENTO)) {
						variantBadge = "success";
					}
					if (["APLICACIÓN", "TRASPASO USO DE PRODUCTO"].includes(application.TIPO_DE_MOVIMIENTO)) {
						variantBadge = "neutral";
					}
					if (application.TIPO_DE_MOVIMIENTO === "NOTA DE CRÉDITO") {
						variantBadge = "warning";
					}
					if (application.TIPO_DE_MOVIMIENTO === "ROBO") {
						variantBadge = "danger";
					}

					return (
						<tr key={index}>
							<td className={classes.tableTd}>{application.NOMBRE_COMERCIAL}</td>
							<td className={classes.tableTd}>
								<CustomBadge variant={variantBadge}>
									{application.TIPO_DE_MOVIMIENTO === "APLICACIÓN" ? "USO DE PRODUCTO" : application.TIPO_DE_MOVIMIENTO}
								</CustomBadge>
							</td>
							<td className={classes.tableTd}>{application.FECHA}</td>
							{applyFilterType === "detail" && (
								<td className={classes.tableTd}>
									<strong> {application.IDENTIFICADOR} </strong>
								</td>
							)}
							<td className={`${classes.tableTd} ${classes.number}`}>
								{application.ENTRY ? (
									<>{`${formatMilesDecimalNew(PRESENTACION_ENVASE_DISPLAY)} ${application.UNIDAD_DE_MEDIDA}`}</>
								) : (
									`0 ${application.UNIDAD_DE_MEDIDA}`
								)}
							</td>
							<td className={`${classes.tableTd} ${classes.number}`}>
								{application.ENTRY ? (
									<>{`${formatMilesDecimalNew(CANTIDAD_PRODUCTO_DISPLAY)} ${application.UNIDAD_DE_MEDIDA}`}</>
								) : (
									`0 ${application.UNIDAD_DE_MEDIDA}`
								)}
							</td>
							<td className={`${classes.tableTd} ${classes.number}`}>{`${formatMilesDecimalNew(BALANCE_DISPLAY)} ${
								application.UNIDAD_DE_MEDIDA
							}`}</td>
						</tr>
					);
				})}
			</tbody>
		</Table>
	);
};

export default Applications;
